module.exports = __webpack_public_path__ + "img/with_accessories.957b967c.jpg";